import { hasOwnProperty } from '../../tn.common';

/**
 * @ngdoc filter
 * @name keysInObj
 * @param {Array<string>} keys The source key array
 * @param {Object} obj The object to grab keys from
 * @description
 * Returns the overlap between the source array and Object.keys(obj).
 */
export function keysInObjFilter() {
    return (keys, obj) => keys.filter((key) => hasOwnProperty(obj, key));
}
